import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import Modal from 'react-bootstrap/Modal';
const initialFieldValues = {
    stateId: "00000000-0000-0000-0000-000000000000",
    stateName: ""
};
export default function State() {
    const [lists, setLists] = useState([]);
    const [allData, setAllData] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [stateName, setStateName] = useState("");
    const [values, setValues] = useState(initialFieldValues);
    const [recordForEdit, setRecordForEdit] = useState(null);
    const [errors, setErrors] = useState({});
    const [btnSubmit, setBtnSubmit] = useState(true);
    const [addShow, setAddShow] = useState(false);
    const handleAddClose = () => {
        setAddShow(false);
        setRecordForEdit(null);
        setValues(initialFieldValues);
    };

    const handleAddShow = () => {
        setRecordForEdit(null);
        setValues(initialFieldValues);
        setAddShow(true);
    };
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
            "Content-Type": "application/json"
        }
    }
    useEffect(() => {
        if (recordForEdit !== null) {
            setValues(recordForEdit);
        }
    }, [recordForEdit]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setValues({
            ...values,
            [name]: value,
        });
    };
    const toInputUppercase = e => {
        e.target.value = ("" + e.target.value).toUpperCase();
    };
    const validate = () => {
        let temp = {};
        temp.stateName = values.stateName === "" ? false : true;
        setErrors(temp);
        return Object.values(temp).every((x) => x === true);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            setBtnSubmit(false);
            var formData = {
                "stateId": values.stateId,
                "stateName": values.stateName
            }
            addOrEdit(formData);
        }
    };
    const applicationAPI = () => {
        return {
            create: (newrecord) =>
                axios.post(config.APIACTIVATEURL + config.CREATESTATE, newrecord, { ...headerconfig }),
            update: (updateRecord) =>
                axios.put(config.APIACTIVATEURL + config.UPDATESTATE, updateRecord, { ...headerconfig })
        };
    };
    const addOrEdit = (formData) => {
        if (formData.stateId === "00000000-0000-0000-0000-000000000000") {
            applicationAPI()
                .create(formData)
                .then((res) => {
                    if (res.data.statusCode === 200) {
                        handleSuccess("Record Created");
                        resetForm();
                        GetData();
                        setBtnSubmit(true);
                    }
                    else {
                        handleError(res.data.data);
                        setBtnSubmit(true);
                    }
                })
                .catch(function (error) {
                    handleError("Error in saving data");
                    setBtnSubmit(true);
                });
        } else {
            applicationAPI()
                .update(formData)
                .then((res) => {
                    if (res.data.statusCode === 200) {
                        handleSuccess("Record Updated");
                        resetForm();
                        GetData();
                        setBtnSubmit(true);
                    }
                    else {
                        handleError(res.data.message);
                        setBtnSubmit(true);
                    }
                })
                .catch(function (error) {
                    handleError("Error in updating data");
                    setBtnSubmit(true);
                });
        }
    };
    const resetForm = () => {
        setValues(initialFieldValues);
        setErrors({});
        handleAddClose();
        setStateName("");
        setSearchTerm("");
    };
    const showEditDetails = (data) => {
        setRecordForEdit(data);
        setValues(data);
        setAddShow(true);
    };
    const onDelete = (e, id) => {
        if (window.confirm('Are you sure to delete this record?')) {
            axios.delete(config.APIACTIVATEURL + config.DELETESTATE + "/" + id, { ...headerconfig })
                .then((response) => {
                    if (response.data.statusCode === 200) {
                        handleSuccess(response.data.message);
                        GetData();
                        resetForm();
                    }
                    else {
                        handleError(response.data.message);
                        GetData();
                    }
                });
        }
    }
    const GetData = () => {
        axios
            .get(config.APIACTIVATEURL + config.GETAllSTATE, { ...headerconfig })
            .then((response) => {
                if (response.status === 200) {
                    setLists(response.data.data);
                    setAllData(response.data.data);
                }
            });
    };
    const filteredLenders = lists.filter((lender) => {
        const matchesSearch = lender.stateName.toLowerCase().includes(searchTerm);
        return matchesSearch;
    });
    const handleSearch = (e) => {
        const value = e.target.value;
        setStateName(value); // this is just the string being typed
        setSearchTerm(value.toLowerCase()); // used for filtering
        setShowSuggestions(true);
    };
    const handleSelect = (lenderdata) => {
        setStateName(lenderdata.stateName);
        setSearchTerm(lenderdata.stateName.toLowerCase());
        setShowSuggestions(false);
    }
    const applyErrorClass = (field) =>
        field in errors && errors[field] === false ? " form-control-danger" : "";
    useEffect(() => {
        GetData();
    }, [])
    return (
        <div id="layout-wrapper">
            <LayoutHeader></LayoutHeader>
            <LayoutSideBar></LayoutSideBar>
            <div className="body-wrapper">
                <div className="container-fluid">
                    <div class="card card-body py-3">
                        <div className="row g-4 align-items-center">
                            <div className="col-sm-9">
                                <div className="search-box">
                                    <input type="text" autoComplete="off" className="form-control search" placeholder="Search states..." name="stateName" onChange={handleSearch} value={stateName} />
                                    <i className="ri-search-line search-icon" />
                                    {showSuggestions && stateName && (
                                    <ul className="locationListVideo scrollable-list" style={{ minWidth: "350px" }}>                                        
                                        {allData.length > 0 && allData.filter((m) => m.stateName.toLowerCase().includes(searchTerm)).map(m =>
                                            <li className="locationListVideoItem" onClick={() => handleSelect(m)}>{m.stateName}</li>
                                        )}
                                    </ul>)}
                                </div>
                            </div>
                            <div className="col-sm-auto ms-auto">
                                <div className="hstack gap-2">
                                    <button type="button" className="btn btn-danger" onClick={resetForm} >Clear</button>
                                    <button type="button" className="btn btn-primary add-btn" onClick={handleAddShow} ><i className="ri-add-line align-bottom me-1" /> Add State</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card card-body py-3">
                        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                            <h4 className="mb-2">States</h4>
                        </div>
                        <div className="table-responsive table-card">
                            <table className="table align-middle" id="customerTable">
                                <thead>
                                    <tr>
                                        <th>Id</th>
                                        <th>Name</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody className="list form-check-all">
                                    {filteredLenders.length > 0 && filteredLenders.map((v, index) =>
                                        <tr key={v.stateId}>
                                            <td>{index + 1}</td>
                                            <td>{v.stateName}</td>
                                            <td>
                                                <ul className="list-inline hstack gap-2 mb-0">
                                                    <li className="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Edit">
                                                        <Link className="edit-item-btn" onClick={e => showEditDetails(v)}><i className="ri-pencil-fill align-bottom text-muted" /></Link>
                                                    </li>
                                                    <li className="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Delete">
                                                        <Link className="remove-item-btn" onClick={e => onDelete(e, v.stateId)}>
                                                            <i className="ri-delete-bin-fill align-bottom text-muted" />
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <Modal
                    show={addShow}
                    onHide={handleAddClose}
                    onExited={() => {
                        setRecordForEdit(null);
                        setValues(initialFieldValues);
                    }}
                >
                    <Modal.Header>
                        <Modal.Title>{values.stateId === "00000000-0000-0000-0000-000000000000" ? "Add" : "Edit"} State</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                            <div className="row">
                                <div className="col-lg-12 mb-3">
                                    <label htmlFor="name" className="form-label">Name</label>
                                    <input type="text" value={values.stateName} name="stateName" onChange={handleInputChange} className={"form-control" + applyErrorClass('stateName')} placeholder="Please Enter State Name" />
                                    {errors.stateName === false ? (<div className="validationerror">Please enter state name </div>) : ('')}
                                </div>
                                <Modal.Footer>
                                    <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                                        {
                                            btnSubmit === true ?
                                                <button type="submit" className="btn btn-primary">{values.stateId === "00000000-0000-0000-0000-000000000000" ? "Submit" : "Update"}</button>
                                                :
                                                <button type="submit" className="btn btn-primary" disabled>Please wait...</button>
                                        }
                                        <button type="button" className="btn btn-danger" onClick={resetForm}>Cancel</button>
                                    </div>
                                </Modal.Footer>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    );
}